<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: "PingFangTC-Regular";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body,
html {
  margin: 0;
  padding: 0;
  font-family: "PingFangTC-Regular";
}
a {
  text-decoration: none;
  color: #26405c;
}
ul,
li {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue